(function () {
    'use strict';
    var m = angular.module('app');
    m.service('autologinHelper', ["$location", "$cookies", function ($location, $cookies) {
        var status = false;
        var firstTimeTokenForCheckpoint = null;
        var isLoggedIn = false;
        var route = null;
        var spogSrc = window.localStorage.getItem('spogSrc');
        var authtokenForSonicwall = null;
        var noRedirect = false;
        var serialNumber = null;
        return {
            init: function () {
                if ($location.search().route) {
                    console.log('autologin-helper route', $location.search().route);
                    var routeParam = $location.search().route;
                    if (routeParam.endsWith('#/')) {
                        routeParam = routeParam.substring(0, routeParam.length - 2);
                    }
                    route = window.atob(decodeURIComponent(routeParam));
                }
                if ($location.search().firstTimeToken) {
                    console.log('checkpoint autologin-helper firsttimetoken');
                    firstTimeTokenForCheckpoint = $location.search().firstTimeToken;
                    status = true;
                }
                if ($location.search().spogSrc) {
                    console.log('sonicwall autologin-helper spogSrc');
                    spogSrc = window.atob($location.search().spogSrc);
                    window.localStorage.setItem('spogSrc', spogSrc);
                }
                if ($location.search().authtoken) {
                    console.log('sonicwall autologin-helper authToken');
                    authtokenForSonicwall = $location.search().authtoken;
                    status = true;
                }
                if ($location.search().noredirect) {
                    console.log('noredirect param found');
                    noRedirect = true;
                }
                if ($location.search().domain) {
                    console.log('sonicwall domain - serial number found');
                    serialNumber = $location.search().domain;
                }
            },
            first_time_token: function () {
                return firstTimeTokenForCheckpoint || authtokenForSonicwall;
            },
            enabled: function (newState) {
                if (!_(newState).isUndefined()) {
                    status = newState;
                }
                return status;
            },
            isLoggedIn: function (newState) {
                if (!_(newState).isUndefined()) {
                    isLoggedIn = newState;
                    if (firstTimeTokenForCheckpoint) {
                        console.log('Cookie stored autologin status for CP.');
                        $cookies.put('autologinCP', true);
                    }
                }
                return isLoggedIn;
            },
            decodedRoute: function (isClear) {
                if (isClear) {
                    route = null;
                }
                return route;
            },
            spogSrc: function () {
                return spogSrc;
            },
            checkAutologinType: function () {
                if (firstTimeTokenForCheckpoint) {
                    return 'CP';
                } else if (authtokenForSonicwall) {
                    return 'SW';
                }
                return null;
            },
            noRedirect: function () {
                return noRedirect;
            },
            serialNumber: function () {
                return serialNumber;
            }
        };
    }]);
}());